import MappingBase from './mappingBase.js';
import telemetryFieldMappings from './telemetryFieldMappings.json';

// alias → full-name registry (drop the generator timestamp). Shared across
// event + batch; aliases are globally unique so a single map is unambiguous.
const { _generated, ...ALIAS_MAP } = telemetryFieldMappings;

/**
 * A single telemetry event. toAlias() emits the aliased wire shape; `ts` has
 * no alias (alias == field name) so it passes through, and props/device_summary
 * are free-form objects passed by reference (NOT recursed — their keys are
 * arbitrary). undefined fields are skipped at construction.
 */
export default class TelemetryEvent extends MappingBase {
  static _aliasMapping = ALIAS_MAP;

  constructor(data = {}) {
    super();
    const map = TelemetryEvent._aliasMapping;
    for (const [k, v] of Object.entries(data)) {
      if (v === undefined) continue;
      this[map[k] || k] = v;
    }
  }
}
